import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { components, elements } from '@peachjar/components';
import GoLiveSvg from '../elements/GoLive.svg';
import PaperPage from '../elements/PaperPage';
import CircleList from '../elements/CircleList';
import GoLiveButton from './GoLiveButton';
import config from '../../../../config';

const PDF_URL = `${config.REACT_APP_CDN_URL}/portal-app/onboarding/Peachjar+FAQs.pdf`;

const {
  Buttons: { ButtonSecondarySmall },
} = components;
const { Paragraph } = elements.typography;

const GoLivePage = () => (
  <PaperPage title="Hurray, you're verified!">
    <Grid item xs={12} md={8} className="mb-5">
      <Typography variant="headline">
        Going live is the last step. Here is what it means:
      </Typography>
      <CircleList>
        <li>
          In the next 24 hours after you go live we will send out a Peachjar
          welcome email to all the parents in your list.
        </li>
        <li>
          Your district and schools will be available for organizations to send
          flyers to for approval.
        </li>
        <li>
          Be prepared to answer questions. Here is a link to our Frequently
          Asked Questions to help you out.<br />
        </li>
      </CircleList>
      <a
        style={{ marginLeft: '40px' }}
        target="_blank"
        rel="noopener noreferrer"
        href={PDF_URL}
      >
        <ButtonSecondarySmall>Peachjar FAQs</ButtonSecondarySmall>
      </a>
    </Grid>

    <Grid container xs={12} justify="space-between" alignItems="center">
      <Paragraph>
        When you are ready, select Go Live and log in to your Peachjar account.
      </Paragraph>
      <GoLiveButton />
    </Grid>

    <Grid container direction="row" justify="center" alignItems="center">
      <Grid item xs={12} md={8}>
        <div
          style={{
            display: 'block',
            margin: '125px 0px',
            position: 'relative',
            left: '4.62%',
          }}
        >
          <GoLiveSvg />
        </div>
      </Grid>
    </Grid>
  </PaperPage>
);

export default GoLivePage;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/go-live/components/GoLivePage.jsx